/**
 * A real silent clip for media keepalive, and the question of whether one
 * is needed at all.
 *
 * Phones suspend a page when the screen turns off unless it is playing
 * media, so long narrations use a silent looping <audio> beside the real
 * one. The clip that did this job used to be a 44-byte WAV with ZERO bytes
 * of audio, looping. While real audio played, nobody noticed. The moment
 * the real audio was paused, that zero-length loop was the only media
 * "playing": it ended and restarted endlessly, and every restart fed the
 * operating system's media controls another update. On Windows that is
 * serviced by the browser's UI process, which is why the tab's contents
 * kept working while the tab strip, the back button and the address bar
 * froze until the browser was killed.
 *
 * So: two seconds of genuine silence, generated here, and only on the
 * devices that suspend pages in the first place.
 */

let cachedUrl = null;

export function isMobileBrowser() {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

/** Object URL of a 2 s, 8 kHz, 8-bit mono WAV of silence. */
export function silentWavUrl() {
    if (cachedUrl) return cachedUrl;
    const rate = 8000, seconds = 2, samples = rate * seconds;
    const buf = new ArrayBuffer(44 + samples);
    const v = new DataView(buf);
    const str = (o, s) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
    str(0, 'RIFF'); v.setUint32(4, 36 + samples, true); str(8, 'WAVE');
    str(12, 'fmt '); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
    v.setUint32(24, rate, true); v.setUint32(28, rate, true); v.setUint16(32, 1, true); v.setUint16(34, 8, true);
    str(36, 'data'); v.setUint32(40, samples, true);
    new Uint8Array(buf, 44).fill(128);  // 8-bit PCM silence is 0x80
    cachedUrl = URL.createObjectURL(new Blob([buf], { type: 'audio/wav' }));
    return cachedUrl;
}
